export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  image: string;
  category: string;
}

export const featuredArticles: Article[] = [
  {
    slug: 'yoybuy-spreadsheet-guide',
    title: 'YOYBUY Spreadsheet: полное руководство 2026',
    excerpt: 'Узнайте всё о системе YOYBUY Spreadsheet — от базовых функций до продвинутых стратегий управления заказами из Китая.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20with%20laptop%20displaying%20spreadsheet%20data%2C%20warm%20ambient%20lighting%2C%20clean%20desk%20with%20coffee%20cup%2C%20soft%20beige%20and%20cream%20tones%2C%20editorial%20style%20photography%20with%20shallow%20depth%20of%20field&width=600&height=400&seq=article-card-01&orientation=landscape',
    category: 'YOYBUY',
  },
  {
    slug: 'kakobuy-spreadsheet-guide',
    title: 'Kakobuy Spreadsheet: руководство для начинающих',
    excerpt: 'Как использовать Kakobuy Spreadsheet для заказов из Китая. Пошаговое руководство и советы.',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20setup%20with%20laptop%20showing%20order%20management%20interface%2C%20notebook%20and%20pen%2C%20warm%20natural%20light%20from%20window%2C%20minimalist%20aesthetic%2C%20soft%20cream%20and%20beige%20palette%2C%20lifestyle%20photography&width=600&height=400&seq=article-card-02&orientation=landscape',
    category: 'Kakobuy',
  },
  {
    slug: 'yoybuy-vs-kakobuy-vs-superbuy',
    title: 'YOYBUY vs Kakobuy vs Superbuy: сравнение 2026',
    excerpt: 'Полное сравнение трёх spreadsheet-систем для заказов из Китая. Какую платформу выбрать?',
    image: 'https://readdy.ai/api/search-image?query=Three%20smartphones%20side%20by%20side%20on%20a%20clean%20marble%20surface%20displaying%20comparison%20charts%2C%20warm%20morning%20light%2C%20minimalist%20flat%20lay%20style%2C%20soft%20neutral%20tones%2C%20editorial%20product%20photography&width=600&height=400&seq=article-card-03&orientation=landscape',
    category: 'Сравнение',
  },
];